import { GetAssetResponse } from "../../api/optima_image/OptimaImageClient";
import { getMediaLinkAsJson, handleMediumPreviewClick } from "../question/edit/functions/questionDtoFunctions";
import { MediaDto } from "../../api/Client";
import { iImageLink } from "./interfaces";
import DeprecatedTooltip from "../common/DeprecatedTooltip";

const getTitle = (image: GetAssetResponse): string => {
  //get title property
  const found = image.properties?.find((x) => x.name === "Filename");

  if (found) {
    return found?.value!;
  }

  return "";
};
const getLastModifiedDate = (image: GetAssetResponse): string => {
  //get title property
  const found = image.properties?.find((x) => x.name === "Last Modified");
  if (found) {
    return found?.value!;
  }
  return "";
};
const getDescription = (image: GetAssetResponse): string => {
  //get title property
  const found = image.properties?.find((x) => x.name === "File Description");
  if (found) {
    return found?.value!;
  }
  return "";
};

// TEMP type until class is auto regenerated
type AssetResponse = GetAssetResponse & { deprecated?: boolean };

const ImageSelector = (props: any) => {
  //TODO: Media Service

  const images: GetAssetResponse[] = props.images;

  const onImageClick = (image: GetAssetResponse) => {
    props.onImageClick(image);
  };

  const onImagePreviewClick = (image: GetAssetResponse) => {
    const mediaLink: iImageLink = getMediaLinkAsJson(image);

    let medium: MediaDto = { link: JSON.stringify(mediaLink), linkTypeId: 1 } as MediaDto;
    let url = image.url!;
    handleMediumPreviewClick(medium, url);
  };

  return (
    <>
      <div style={{ columnCount: props.cols }} className="tooltipContainer">
        {images.map((x: AssetResponse, index: number) => (
          <figure key={index + "_" + x.contentId}>
            <img
              onClick={() => onImageClick(x)}
              src={x.url + "?f=avif&w=400"}
              alt={"thumb_" + getTitle(x)}
              style={{ cursor: "pointer" }}
            />
            <figcaption key={x.contentId}>
              <span title="Namn">{getTitle(x)}</span>
              <br />
              <span title="Ändrad">{getLastModifiedDate(x)}</span>
              <br />
              <span title="Beskrivning">{getDescription(x)}</span>
            </figcaption>

            <div key={x.versionId}>
              <div
                key={"btndiv_" + x.contentId}
                style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}
              >
                <button
                  className="k-button k-button-md k-rounded-md k-button-flat k-button-flat-base"
                  onClick={() => onImagePreviewClick(x)}
                >
                  <span className={"k-icon k-i-eye"} />
                </button>
                {x.deprecated && <DeprecatedTooltip id={"thumb_" + index} container=".tooltipContainer" />}
              </div>
            </div>
          </figure>
        ))}
      </div>
    </>
  );
};

export default ImageSelector;
